function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_76",
  "data-name": "Group 76",
  transform: "translate(-165.209 -7659.487)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_2",
  transform: "translate(226.16 7898.941)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_268",
  "data-name": "Path 268",
  d: "M597.921,95.14c0,23.741-91.176,42.626-203.411,43.167S191.1,119.415,191.1,95.675s91.176-42.626,203.411-43.167S597.921,71.4,597.921,95.14Z",
  transform: "translate(-191.1 -52.497)",
  fill: "#de7ba1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  transform: "matrix(-0.656, -0.755, 0.755, -0.656, 430.528, 8134.163)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1-2",
  transform: "translate(0.105 0.511)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_3",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_269",
  "data-name": "Path 269",
  d: "M0,0S5.935,4.315,15.645,11.87c9.716,8.1,23.741,19.426,39.926,34.008a696.421,696.421,0,0,1,103.6,121.375,496.605,496.605,0,0,1,41.006,76.617,256.217,256.217,0,0,1,19.426,75,104.928,104.928,0,0,1-9.17,56.111,45.961,45.961,0,0,1-9.17,13.491l-3.775,4.315,3.235-4.855A66.2,66.2,0,0,0,207.2,373.9a103.848,103.848,0,0,0,2.16-52.847c-7.55-43.167-33.973-94.963-65.287-142.438A1126.328,1126.328,0,0,0,48.022,53.957C33.991,37.748,22.12,24.281,13.491,15.1,4.855,5.4,0,0,0,0Z",
  fill: "#7c8d3b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  transform: "translate(0 0.285)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_270",
  "data-name": "Path 270",
  d: "M0,0S5.935,4.315,15.645,11.87c10.25,7.55,24.821,17.806,42.086,30.2S95.48,68.5,118.163,83.075c22.649,14.031,46.941,29.136,71.762,42.086C239.562,151.6,292.978,173.723,335.6,178.009a131.49,131.49,0,0,0,29.136,0,64.2,64.2,0,0,0,22.12-5.935,68.777,68.777,0,0,0,13.491-8.1l4.315-3.775-3.775,4.315A73.675,73.675,0,0,1,388.475,174.8a101.821,101.821,0,0,1-54.5,12.951,238.818,238.818,0,0,1-74.968-13.479,439.566,439.566,0,0,1-78.772-33.991A697.5,697.5,0,0,1,50.716,49.636C34.531,35.611,22.12,22.649,12.951,13.491,4.855,5.4,0,0,0,0Z",
  fill: "#7c8d3b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3",
  transform: "translate(0.197 0.139)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_5",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_271",
  "data-name": "Path 271",
  d: "M0,0S24.821,18.346,59.352,48.022c17.265,15.1,37.231,32.911,57.732,52.847s42.086,42.086,62.587,64.747c41.012,45.35,78.76,94.446,100.9,135.452a168.9,168.9,0,0,1,20.5,53.428,29.81,29.81,0,0,1-1.62,16.725,37.868,37.868,0,0,1-3.235,4.855,16.162,16.162,0,0,0,2.16-5.4,30.965,30.965,0,0,0-1.08-15.645c-3.235-12.951-13.491-29.676-25.9-48.022A1352.593,1352.593,0,0,0,165.116,178.6C124.65,133.3,82.564,89.574,51.291,56.123,35.646,39.4,22.7,25.344,13.543,15.657A179.789,179.789,0,0,1,0,0Z",
  fill: "#7c8d3b"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4",
  transform: "translate(0.256 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_272",
  "data-name": "Path 272",
  d: "M0,0S5.4,3.775,14.565,10.79s22.649,16.725,38.846,28.6C85.247,63.127,127.328,95.5,170.494,126.253A1106.783,1106.783,0,0,0,292.45,205.025c17.805,9.17,32.911,15.645,44.241,16.725a29.107,29.107,0,0,0,13.491-1.62,11.749,11.749,0,0,0,4.315-2.7l-3.775,3.775a22.144,22.144,0,0,1-14.031,3.775,140.2,140.2,0,0,1-49.1-10.25c-38.329-14.565-84.707-42.086-128.414-72.837-21.58-15.645-42.626-31.836-62.046-48.022-18.886-16.185-36.691-31.836-50.716-45.3C17.265,20.5,0,0,0,0Z",
  fill: "#7c8d3b"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Path_3-2",
  transform: "translate(225.62 7941.044)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_273",
  "data-name": "Path 273",
  d: "M542.25,385.649H254.127L191,60.84s151.074,42.626,203.411,42.626S597.821,60.3,597.821,60.3Z",
  transform: "translate(-191 -60.3)",
  fill: "#dc2c6f"
})));

var SvgPot = function SvgPot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562.129,
    height: 606.908,
    viewBox: "0 0 562.129 606.908",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pot.c2aa1334.svg";
export { ForwardRef as ReactComponent };